import React from 'react'
import classnames from 'classnames'
import { container, stepPath } from './ContactHeader.module.scss'
import { Title } from '../../ui/Title'

const step = ['入力', '確認', '完了']

type Props = {
	currentStep: number
}

export const ContactHeader = ({ currentStep }: Props) => {
	return (
		<div className={classnames(container, 'flex flex-col lg:flex-row justify-between items-start lg:items-end')}>
			<Title title="お問い合わせ" titleSub="CONTACT" tag="h1" horizontal={false} className="flex-col" />
			<div className="flex justify-center mt-8 lg:mt-0 w-full lg:w-auto">
				{step.map((step, i) => {
					return (
						<div
							key={step}
							className={classnames(
								i < currentStep ? 'opacity-100' : 'opacity-50',
								`${i === 0 ? '' : 'ml-14'}`,
								stepPath
							)}
						>
							<p className="inline-flex justify-center items-center w-8 h-8 text-sm text-secondary bg-blue rounded-circle">
								{i + 1}
							</p>
							<p className="mt-2 text-sm">{step}</p>
						</div>
					)
				})}
			</div>
		</div>
	)
}
